module.exports = __webpack_public_path__ + "img/guizhouHints_13.fbf8ae05.jpg";